import { render, staticRenderFns } from "./IntegrationHooks.vue?vue&type=template&id=4cbc00b3&scoped=true&"
import script from "./IntegrationHooks.vue?vue&type=script&lang=js&"
export * from "./IntegrationHooks.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationHooks.vue?vue&type=style&index=0&id=4cbc00b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc00b3",
  null
  
)

export default component.exports